import type { MenuConfig } from '~typings/menu'

import permisosInventario, { RESOURCE_INVENTARIO } from '@/auth/permissions/modules/inventario'
import * as names from '@routes/inventario-consumo/nombres/configuracion'

const { configuracion } = permisosInventario
export default [
    {
        title: 'inventario.subopciones.destinatarios',
        route: names.ROUTE_DESTINATARIOS,
        resource: RESOURCE_INVENTARIO,
        action: configuracion.destinatarios,
    },
    {
        title: 'inventario.subopciones.asignar_jefe_bodega',
        route: names.ROUTE_JEFE_BODEGA,
        resource: RESOURCE_INVENTARIO,
        action: configuracion.jefeBodega,
    },
    {
        title: 'inventario.subopciones.nivel_aprobacion_item_categoria',
        route: names.ROUTE_NIVEL_APROBACION_ITEM_CATEGORIA,
        resource: RESOURCE_INVENTARIO,
        action: configuracion.nivelAprobacionItemxCategoria,
    },
    {
        title: 'inventario.subopciones.permisos_niveles_aprobacion_orden_pedido',
        route: names.ROUTE_NIVEL_APROBACION_ORDEN_PEDIDO,
        resource: RESOURCE_INVENTARIO,
        action: configuracion.nivelAprobacionOrdenPedido,
    },
    {
        title: 'inventario.subopciones.permisos_bodega',
        route: names.ROUTE_PERMISOS_BODEGA,
        resource: RESOURCE_INVENTARIO,
        action: configuracion.permisosBodega,
    },
    {
        title: 'inventario.subopciones.politica_items',
        route: names.ROUTE_POLITICA_ITEM,
        resource: RESOURCE_INVENTARIO,
        action: configuracion.politicaItem,
    },
    {
        title: 'inventario.subopciones.stock_minimo',
        route: names.ROUTE_STOCK_MINIMO,
        resource: RESOURCE_INVENTARIO,
        action: configuracion.stockMinimo,
    },
] as MenuConfig[]
